export default __webpack_public_path__ + "static/push-d10c6292585f3cd2c64d15d83fd9abca.png";